/**
 * Lógica PURA del par de un hilo DM (👥 Wave 1, agente D). El hilo se deduplica
 * por un par CANÓNICO ordenado (user_a < user_b) con independencia de quién lo
 * inicie; el "otro participante" se resuelve respecto a quién mira. Sin DB.
 */

/** Par canónico ordenado [min, max] (orden lexicográfico) de dos usuarios. */
export function canonicalPair(a: string, b: string): [string, string] {
  return a <= b ? [a, b] : [b, a];
}

export interface ThreadParticipants {
  user_a: string | null;
  user_b: string | null;
  a_name?: string | null;
  a_image?: string | null;
  b_name?: string | null;
  b_image?: string | null;
}

export interface Participant {
  id: string;
  name: string | null;
  image: string | null;
}

/**
 * El OTRO participante del hilo respecto a `me` (con su nombre/imagen
 * desnormalizados). Si `me` no es `user_a`, se asume que es `user_b` (o un
 * observador): se devuelve el extremo A.
 */
export function otherParticipant(thread: ThreadParticipants, me: string): Participant {
  if (thread.user_a === me) {
    return { id: thread.user_b ?? "", name: thread.b_name ?? null, image: thread.b_image ?? null };
  }
  return { id: thread.user_a ?? "", name: thread.a_name ?? null, image: thread.a_image ?? null };
}
